import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import {Link, useNavigate} from "react-router-dom";

import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import MandantUserAdminService from "../../../services/MandantUserAdminService";

import Button from "@mui/material/Button";
import { EXTERN_USERADMINISTRATION_URL } from "../../../modules/config";
import MaterialTable from "@material-table/core";

import { header } from'../../../shared/headerStyle';
import {buildRealmPath} from "../../../shared/routing";


function MandantUserList() {

    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const [users, setUsers] = useState([]);

    const filtering = false;
    const isLoading = false;
    const tableRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchUsers() {
            try {
                const result = await MandantUserAdminService.getKeycloakUser(token, realm);
                if (result?.data instanceof Array) {
                    setUsers(result.data);
                }
            } catch (e) {
                console.error(e);
            }
        }
        fetchUsers();
    }, [realm, token]);

    const handleEditClick = (event, rowData) => {
        navigate(buildRealmPath(realm, `/mandantuseredit/${rowData.id}`));
    };

    const getGroupString = (data) => {
        if (!data.groups?.length) return '';
        return data.groups.map(gr => gr.name).join(', ');
    };
    const tableHeight = `calc(100vh - ${66 + 74 + 56 + 52 + 24}px)`; // page-header + toolbar + col-header + pagination + padding

    return (
        <TableContainer component={Paper} style={{ padding: '12px', boxSizing: 'border-box' }}>
            <div className="row">
                <div className="col-sm-12">
                    <h3>{realm}</h3>
                    <div>
                        <Link to={buildRealmPath(realm, '/MandantUserCreate')}><Button type="button" color="primary" variant="outlined" size="medium" >Benutzer hinzufügen</Button></Link>
                        <a href={`${EXTERN_USERADMINISTRATION_URL}/${realm}`} target="extUV"><Button type="button" color="primary" variant="outlined" size="medium" >externe Benutzerverwaltung</Button></a>
                    </div>

                </div>
            </div>

            <MaterialTable
                tableRef={tableRef}
                title="Benutzer"
                columns={[
                    { title: 'Username', field: 'username' },
                    { title: 'Vorname', field: 'firstName'},
                    { title: 'Nachname', field: 'lastName' },
                    { title: 'E-Mail', field: 'email'},
                    { title: 'Gruppen', field: 'type', render: (rowData) => {
                            return getGroupString(rowData)}
                    }

                ]}
                data={users}

                onRowClick={(event, rowData) => handleEditClick(event, rowData)}
                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: (rowData.deactivated) ? '#EEE' : null,
                        fontSize: "0.8em"
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    filtering,
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: tableHeight,
                    minBodyHeight: tableHeight,
                }}
                actions={[

                    {
                        icon: 'edit',
                        tooltip: 'Editieren',
                        onClick: (event, rowData) => handleEditClick(event, rowData)
                    },

                ]}
                isLoading={isLoading}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}

            />
        </TableContainer>
    );
}

export default MandantUserList;